import getIdentifierType from "../getIdentifierType";
import getUpdatedNodeTypeCount from "../getUpdatedNodeTypeCount";

export const getIdentifierMapWithoutDivs = (rawText) => {
  const identifierMap = {};

  let divCount = 1;
  let currentNodeIsImage = false;

  let totalNodeTypeCount = {};
  let currentDivChildrenNodeTypeCount = {};

  for (const node of rawText.content) {
    totalNodeTypeCount = getUpdatedNodeTypeCount(node, totalNodeTypeCount);

    // Increment the div count when the node is an image or the previous node was an image
    if (currentNodeIsImage) {
      currentNodeIsImage = false;
      divCount++;
      currentDivChildrenNodeTypeCount = {};
    }

    if (node.type === "image_block") {
      currentNodeIsImage = true;
      divCount++;
      currentDivChildrenNodeTypeCount = {};
    }

    currentDivChildrenNodeTypeCount = getUpdatedNodeTypeCount(
      node,
      currentDivChildrenNodeTypeCount,
    );

    const identifierType = getIdentifierType(node);
    const currentIdentifier = `/div[${divCount}]/${identifierType}[${currentDivChildrenNodeTypeCount[node.type]}]`;
    const correctIdentifier = `/${identifierType}[${totalNodeTypeCount[node.type]}]`;
    identifierMap[currentIdentifier] = correctIdentifier;
  }

  return identifierMap;
};

/**
 * Update annotations identifiers to account for rendering differences between the Read page and the View page.
 *
 * The Read page sometimes adds extraneous divs to the markup.
 * They need to be removed for consistency between the data sets.
 *
 * Two scenarios have been identified so far:
 * 1. a div wrapping the entire article body
 * 2. in some articles with inline images:
 * - a div wrapping all content before the image
 * - an empty div immediately following the image
 * - a div wrapping the remaining content (or until the next inline image)
 *
 * @param {Array<object>} annotations
 * @returns {Array<object}
 */
const sanitizeAnnotations = (annotations = [], rawText) => {
  const identifierMap = getIdentifierMapWithoutDivs(rawText);
  return annotations.map((annotation) => {
    const start =
      annotation.start.slice(0, 4) === "/div"
        ? identifierMap[annotation.start]
        : annotation.start;
    const end =
      annotation.end.slice(0, 4) === "/div"
        ? identifierMap[annotation.end]
        : annotation.end;

    return { ...annotation, start, end };
  });
};

export default sanitizeAnnotations;
